/**
 * Returns the positive modulo of n % m
 * @param n dividend
 * @param m divisor
 * @returns positive modulo of n % m
 */
export default function positiveMod(n: number, m: number): number {
  return ((n % m) + m) % m;
}
